/* eslint-disable max-lines */

// about vuex
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

// MIT License
//
// Copyright (c) 2020 Innologica Ltd
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../share/config';
import cstmTable from '../../../share/components/vue/PaginationTable';
import loading from '../../../share/components/vue/ProcessingIcon';
import svgButton from '../../../share/components/vue/SVGButton';
import customCard from "../../../share/components/vue/CustomCard";
import cstmPagination from '../../../share/components/vue/Pagination';
import util from '../../../share/util/utils';
import filter from '../../../share/util/filter';
import easyTbl from '../../../share/components/vue/EasyTable';
import apiService from '../../../share/util/api/service';
import errorMapping from '../../../share/util/api/errorMapping';
import handler from '../../../share/util/apiResultValidator';
import alert from '../../../share/alert';
import session from '../../../share/session';
import pfcs from '../../../share/util/pfcs';
import lngSwitch from '../../../share/util/languageSwitching';

const cardOpenHeight = 380;
const cardCloseHeight = 230;

// 大量データをvue管理(data)内で保持するとIEでメモリリークするので、
// 大量データはdata外で保持するようにする。 
let itemsBuff = [];

export default {
  name: "soldVehicle",
  data() {
    return {
      isPublished: true,
      isVisible: false, // 非公開PAKファイルが存在する場合に切り替えボタンを表示するフラグ
      processing: false,
      tabs: [
        { country: config.REGION_DOMESTIC, label: 'message.common_region_domestic' },
        { country: config.REGION_NORTH_AMERICA, label: 'message.common_region_north_america' },
        { country: config.REGION_EUROPE, label: 'message.common_region_europe' }
      ],
      // PAKファイル一覧カラム情報
      jaColumns: [
        { name: 'pack_number', label: 'message.header_sold_vehicle_table_part_number', width: '200px' }, //ECU書換後部番 
        { name: 'vehicle', label: 'message.header_sold_vehicle_table_vehicle_line', width: '200px' }, // 車種
        { name: 'year', label: 'message.header_sold_vehicle_table_minor_change', width: '200px' }, // 型式
        { name: 'model_line', label: 'message.header_sold_vehicle_table_annual_improvements', width: '200px' }, // 年改
        { name: 'engine', label: 'message.header_sold_vehicle_table_engine', width: '200px' }, // エンジン
        { name: 'transmission', label: 'message.header_sold_vehicle_table_t_m', width: '400px' }, // トランスミッション
        { name: 'other', label: 'message.header_sold_vehicle_table_other', width: '200px' }, // その他
        { name: 'affected_unit', label: 'message.header_sold_vehicle_table_unit', width: '200px' }, // コントロールユニット
      ],
      otherColumns: [
        { name: 'pack_number', label: 'message.header_sold_vehicle_table_part_number', width: '200px' }, //ECU書換後部番 
        { name: 'year', label: 'message.header_sold_vehicle_table_model_line', width: '200px' }, // 年式
        { name: 'vehicle', label: 'message.header_sold_vehicle_table_vehicle_line', width: '200px' }, // 車種
        { name: 'specification', label: 'message.header_sold_vehicle_table_emission_spec', width: '200px' }, // 排ガス対応
        { name: 'engine', label: 'message.header_sold_vehicle_table_engine', width: '200px' }, // エンジン
        { name: 'aspiration', label: 'message.header_sold_vehicle_table_aspiration', width: '200px' }, // 吸気方式
        { name: 'transmission', label: 'message.header_sold_vehicle_table_t_m', width: '400px' }, // トランスミッション
        { name: 'affected_unit', label: 'message.header_sold_vehicle_table_cpu', width: '200px' }, // コントロールユニット
      ],
      items: [],

      // 検索条件
      packNumber: "",
      vehicle: "",
      modelLine: "",
      year: "",
      engine: "",
      transmission: "",
      aspiration: "",
      affectedUnit: "",
      specification: "",
      other: "",
      // テーブルの高さ
      tableDifferenceHeight: cardOpenHeight,
      // 詳細ダイアログ
      pakFileDetailDialog: false,
      selectItems: [],
      watcher: null,
      isFilterVehicle: false,
      isFilterModel: false,
      isFilterModelLine: false,
      isFilterYear: false,
      currentPage: 0,
      selectedLanguage: '', // 選択中の言語
      translationLangs: [], // 翻訳言語の選択肢
      completionCheckServiceNews: false, // サービスニュースの確認済みフラグ
      translations: [], // 翻訳言語ごとの表示情報一覧（APIから取得）
      serviceNewsList: [], // サービスニュース表示用テキストリスト(リンクがある場合に表示)
      serviceNewsUrl: '', // サービスニュース URL ベース
      combinedServiceNewsText: '', // サービスニュース表示用テキスト(リンクがない場合に表示)
      problemFixedHistory: '', // コメント/アップデート（仕向け共通）
      attention: '', // 注意事項
      grade: '', // 備考
      // Pagination コントロール情報 
      pageSize: Number(process.env.VUE_APP_MANAGE_PAGE_DISPLAY_COUNT),
      itemLength: 0
    };
  },
  props: {
    tableData: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  watch: {
    systemTable() {
      if (this.systemTable) {
        this.selectedItemFunc(true);
      }
    },
  },
  components: {
    'cstm-table': cstmTable,
    'svg-button': svgButton,
    'customCard': customCard,
    'processing-view': loading,
    'easy-table': easyTbl,
    'cstm-pagination': cstmPagination,
  },
  methods: {
    ...mapActions('auth', ['logout']),
    ...mapActions('vehicle', ['setReproRegion']),
    ...mapActions('userProperty', ['setUserCache']),

    // 公開・非公開の選択状態に応じて表示対象のPAKデータ一覧を取得
    getDisplayPakList: function () {
      const published = this.systemTable?.published || [];
      const unpublished = this.systemTable?.unpublished || [];
      return this.isPublished ? published : unpublished;
    },

    // 公開・非公開テーブルの切り替え
    switchTable: function () {
      this.isPublished = !this.isPublished;
      this.selectedItemFunc(true);
    },

    // 非公開データが存在する場合のみ、公開・非公開切り替えボタンを表示する
    computeVisible: function () {
      this.isVisible = (this.systemTable?.unpublished?.length ?? 0) > 0;
      // 非公開データが存在しない場合は公開表示に固定する
      if (!this.isVisible) {
        this.isPublished = true;
      }
    },

    // 表示タブの制限
    selectedItemFunc: function (isPaginate = false) {
      this.computeVisible();
      // 仕向け地＝日本かつSUBARU会社所属の場合は「日本」「北米」「欧州一般」のすべてのPAKファイルを表示
      // 上記以外の場合は所属regionのみタブ表示
      const countryGroups = this.systemTable.countryGroups;
      this.tabs = this.tabs.filter(tab => countryGroups.includes(tab.country));
      // 仕向け地情報ごとにフィルター
      // 車両情報・パスワード変更画面からの場合フィルター
      this.switchCountryTab(this.reproRegion ?? this.userRegion ?? config.REGION_DOMESTIC, isPaginate);
    },

    // 検索条件プルダウンの作成
    getPullDownList: function (type) {
      if (!this.systemTable) {
        return null;
      }
      // 車種リスト作成
      return this.makeVehicleInfoList(this.getDisplayPakList(), type);
    },

    makeVehicleInfoList: function (pakList, filterType) {
      const countryPackList = pakList.filter(item => item.country_group === this.reproRegion);
      const vehicleList = countryPackList.map(obj => obj[filterType] ? obj[filterType] : '');
      vehicleList.unshift('');

      // 車種情報が特定できた場合、検索条件に絞り込み表示
      // 車両情報取得から遷移の場合絞り込み
      if (filterType === 'vehicle' && vehicleList.includes(this.systemTable.vehicle) && !this.isFilterVehicle && util.getPreviousDisplayName(this.$route) !== 'changePassword') {
        this.vehicle = this.systemTable.vehicle;
        this.isFilterVehicle = true;
        this.executeFilter(true);
      }
      if (filterType === 'year' && vehicleList.includes(this.systemTable.model) && !this.isFilterModel && util.getPreviousDisplayName(this.$route) !== 'changePassword' && this.systemTable.model) {
        this.year = this.systemTable.model;
        this.isFilterModel = true;
        this.executeFilter(true);
      }
      if (filterType === 'model_line' && vehicleList.includes(this.systemTable.annualImprovements) && !this.isFilterModelLine && util.getPreviousDisplayName(this.$route) !== 'changePassword' && this.systemTable.annualImprovements) {
        this.modelLine = this.systemTable.annualImprovements;
        this.isFilterModelLine = true;
        this.executeFilter(true);
      }
      if (filterType === 'year' && vehicleList.includes(this.systemTable.modelYear) && !this.isFilterYear && util.getPreviousDisplayName(this.$route) !== 'changePassword' && this.systemTable.modelYear) {
        this.year = this.systemTable.modelYear;
        this.isFilterYear = true;
        this.executeFilter(true);
      }
      return Array.from(new Set(vehicleList));
    },

    filterInfo: function (itemList) {
      return itemList.filter(item => item.country_group === this.reproRegion);
    },

    // 仕向け地情報切り替えタブ
    switchCountryTab: function (region, isPaginate) {
      if (!isPaginate) {
        this.clear();
      }
      this.setReproRegion(region);
      // 仕向け地情報ごとにフィルター
      itemsBuff = this.filterInfo(this.getDisplayPakList());
      this.executeFilter(true);
    },

    // 検索の実態処理
    // initFilter初期フィルターフラグ
    executeFilter: function (initFilter = false, initPag = true) {
      if (initPag) {
        this.initPagination();
      }
      let list = [];
      if (this.reproRegion === config.REGION_DOMESTIC) {
        list = itemsBuff
          .filter(itemList => { return filter.compareString(this.packNumber, itemList.pack_number, false); })
          .filter(itemList => { return filter.compareString(this.vehicle, itemList.vehicle, true); })
          .filter(itemList => { return filter.compareString(this.year, itemList.year, true); })
          .filter(itemList => { return filter.compareString(this.modelLine, itemList.model_line, true); })
          .filter(itemList => { return filter.compareString(this.engine, itemList.engine, true); })
          .filter(itemList => { return filter.compareString(this.transmission, itemList.transmission, true); })
          .filter(itemList => { return filter.compareString(this.other, itemList.other, true); })
          .filter(itemList => { return filter.compareString(this.affectedUnit, itemList.affected_unit, true); });
      } else {
        // 北米・欧州一般のテーブル
        list = itemsBuff
          .filter(itemList => { return filter.compareString(this.packNumber, itemList.pack_number, false); })
          .filter(itemList => { return filter.compareString(this.vehicle, itemList.vehicle, true); })
          .filter(itemList => { return filter.compareString(this.year, itemList.year, true); })
          .filter(itemList => { return filter.compareString(this.engine, itemList.engine, true); })
          .filter(itemList => { return filter.compareString(this.aspiration, itemList.aspiration, true); })
          .filter(itemList => { return filter.compareString(this.affectedUnit, itemList.affected_unit, true); })
          .filter(itemList => { return filter.compareString(this.transmission, itemList.transmission, true); })
          .filter(itemList => { return filter.compareString(this.specification, itemList.specification, true); });
      }
      this.items = this.pageSizeFilter(list);
      this.itemLength = list.length;

      // item数が1以下の場合Filterはしない
      if (this.items.length < 1 && initFilter) {
        this.items = itemsBuff;
        this.clear();
      }
    },

    clear: function () {
      this.packNumber = '';
      this.vehicle = '';
      this.modelLine = '';
      this.engine = '';
      this.transmission = '';
      this.affectedUnit = '';
      this.year = '';
      this.aspiration = '';
      this.other = '';
    },

    // 任意のシステムが選択された場合の動作
    clickRow: function (selected) {
      // item情報を入れる
      this.selectItems.push(selected);
      this.completionCheckServiceNews = false;
      this.translations = selected.translations;
      this.updateTranslationList();
      // 初期言語選択
      // キャッシュ済み言語 → 画面表示言語 → デフォルト言語 → translations先頭の言語 の優先順位で初期選択が決定される
      if (this.translations.length > 0) {
        this.selectedLanguage = lngSwitch.extractSelectedLanguage(
          this.translations, this.cachedTranslationLang, this.displayLang
        );
      }
      this.computeTranslations();
      this.pakFileDetailDialog = true;
    },

    // 復号化パスワードのコピー
    copyPassword: function () {
      // クリップボードにコピー
      // 復号化パスワードをコピー
      navigator.clipboard.writeText(this.selectItems[0].keyword);
    },

    // FW2起動ボタン
    executeFw2Repro: async function () {
      this.processing = true;
      const token = session.getToken();
      const param = {
        id_token: token.id_token
      };
      const res = await apiService.postCall(config.REPRO, '/netApps/' + this.netAppId + '/flashWrite/launch?pack_file_id=' + this.selectItems[0].pack_file_id + '&country_group=' + this.selectItems[0].country_group, param);
      // APIレスポンスの検証
      handler.validate(handler.validateTypes.all, res, this, null,
        // 正常応答コールバック
        () => {
          // ステータス監視を開始
          this.watchStatus();
        },
        // 異常応答コールバック
        (result) => {
          // エラーダイアログOK押下後の処理
          this.processing = false;
          if (result.behaviorType === handler.behaviorTypes.logout) this.logout(this);
        },
      );
    },

    // API実行後のステータスを監視
    watchStatus: async function () {
      let retryCnt = 0;
      this.watcher = this.$startInterval(async () => {
        const res = await apiService.getCall(config.REPRO, '/netApps/' + this.netAppId + '/flashWrite/status');
        handler.validate(
          handler.validateTypes.all, res, this, null, () => {
            if (res.data.pak_status === 'error') {
              this.stopWatching();
              this.showModal('error', this.$t(errorMapping.getErrorMessageForCode(res.data.error_code)));
              return;
            }
            // FW/FW2起動完了
            if (res.data.pak_status === 'completed') {
              this.stopWatching();
              this.showModal('complete');
              return;
            }
            // リトライ上限に達した
            if (++retryCnt === Number(process.env.VUE_APP_RETRY_COUNT)) {
              this.showModal('error', this.$t('message.common_processing_retry_error'));
              return;
            }
          },
          (result) => {
            this.stopWatching();
            if (result.behaviorType === handler.behaviorTypes.logout)
              this.logout(this);
          }
        );
      }, process.env.VUE_APP_RETRY_INTERVAL, 'executeFw');
    },

    // ステータス監視を停止
    stopWatching: function () {
      if (this.watcher) {
        this.$stopInterval(this.watcher);
        this.watcher = null;
      }
      this.processing = false;
    },

    SSM5Logout() {
      // SoldInformationMain.jsのtapLogoutを呼び出す
      this.$emit('tapLogout');
    },

    // モーダルを表示
    showModal: function (type, resource) {
      this.stopWatching();
      this.processing = false;
      if (type === 'complete') {
        alert.showSuccess(this, null, this.$t('message.message_success_launch_fw'),
          () => {
            this.pakFileDetailDialog = false;
            this.SSM5Logout();
          }
        );
      } else {
        alert.showError(this, null, resource, () => { });
      }
    },

    closeModal() {
      this.pakFileDetailDialog = false;
      this.selectItems = [];
      this.translations = [];
      this.serviceNewsList = [];
      this.translationLangs = [];
      this.serviceNewsUrl = '';
      this.combinedServiceNewsText = '';
      this.problemFixedHistory = '';
      this.attention = '';
      this.grade = '';
      this.completionCheckServiceNews = false;
    },

    cardCollapsed(value) {
      // テーブルの高さ計算用の関数
      if (value) {
        this.tableDifferenceHeight = cardOpenHeight;
      }
      else {
        this.tableDifferenceHeight = cardCloseHeight;
      }
    },

    switchCountryColums() {
      return this.reproRegion === config.REGION_DOMESTIC ? this.jaColumns : this.otherColumns;
    },

    // テーブルの pagination コントロール選択イベント 
    selectedPAKPage(currentPage) {
      // スクロールバーを初期位置(一番上)に戻す
      this.$refs.custom_table.scrollToTop();
      this.currentPage = currentPage;
      this.executeFilter(false, false);
    },

    initPagination() {
      this.currentPage = 1;
      if (this.$refs.pagination) this.$refs.pagination.initializePagenation();
    },

    // 設定されたページサイズでフィルタリングを実施する
    pageSizeFilter(buffer) {
      let result = [];
      result = buffer.filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        let result = false;
        if (index >= start && index < end) result = true;
        return result;
      });
      return result;
    },

    // 翻訳言語選択リストを生成
    updateTranslationList: function () {
      // リスト初期化
      this.translationLangs = [];
      // リストを生成
      this.translations.forEach((item) => {
        this.translationLangs.push({
          text: lngSwitch.getLabel(this.masterTranslations, item.language, this.displayLang),
          value: item.language
        });
      });
    },

    /**
     * 翻訳データから、選択中の言語に応じた表示情報を抽出してセットする
     */
    computeTranslations: function () {
      const translated = pfcs.buildTranslationDisplay(this.translations, this.selectedLanguage || 'en');

      this.selectedLanguage = translated.selectedLanguage;
      this.serviceNewsUrl = translated.serviceNewsUrl;
      this.serviceNewsList = translated.serviceNewsList;
      this.combinedServiceNewsText = translated.serviceNewsText;

      const selected = translated.selectedTranslation;
      this.problemFixedHistory = selected ? selected.problem_fixed_history : '';
      this.attention = selected ? selected.attention : '';
      this.grade = selected ? selected.grade : '';
    },

    /**
     * 翻訳言語選択時の処理
     * @param {*} selected  選択された言語コード
     */
    updateLanguage: function (selected) {
      if (selected) {
        this.setUserCache({
          key: config.USER_CACHE_REPRO_SYSTEM_TRANSLATION,
          value: selected
        });
        this.selectedLanguage = selected;
        this.computeTranslations();
      }
    },
  },

  computed: {
    ...mapState({
      systemTable: state => state.table.systemTable,
      runPaginateData: state => state.table.runPaginateData,
      vehicleInfo: state => state.vehicle.vehicleInfo,
      reproRegion: state => state.vehicle.reproRegion,
      tableHeight(state) {
        const height = state.app.clientHeight - this.tableDifferenceHeight;
        return height;
      },
      userRegion: state => state.userProperty.region,
      userProperty: state => state.userProperty,
      netAppId: state => state.netAppConnector.pairingAppId,
      masterTranslations: state => state.fileResources.translations,
      displayLang: state => state.systems.language,
      cachedTranslationLang: state => state.userProperty.userCache[config.USER_CACHE_REPRO_SYSTEM_TRANSLATION],
      currentProvider: state => state.provider.currentProvider,
    }),
    // サービスニュースの区切り文字を取得
    getServiceNewsSeparator() { return lngSwitch.getServiceNewsSeparator(); },
  },

  // 画面作成イベント
  mounted() {
    this.selectedItemFunc();
  },

  beforeUnmount() {
    itemsBuff = [];
  }
};
